module.exports = __webpack_public_path__ + "static/images/4b6cfbf715d9908d2eeb3ceb8b88bb97.png";